/**
 * Identidade de uma nota selecionável na aba Pendentes.
 *
 * A tela agrupa em mês > quinzena > imobiliária > filial, e é a FILIAL que vira uma nota - a mesma
 * unidade que o botão individual já emite. Os componentes da árvore e a barra de seleção precisam
 * concordar na chave, senão "selecionar todas" e o checkbox da linha marcam coisas diferentes.
 *
 * A chave são os próprios ids dos pagamentos: é o que identifica a nota de ponta a ponta (é o que
 * vai no request e o que volta na resposta do lote), e não depende de o backend mandar id de filial.
 */
export const buildSelectableInvoice = (realEstateGroup, branch) => {
  const paymentsIds = (branch?.payments_invoices ?? []).map(({ payment_id }) => payment_id)

  return {
    key: paymentsIds.join(','),
    paymentsIds,
    total: branch?.hauseful_total ?? 0,
    realEstate: realEstateGroup?.real_estate?.name ?? '',
    branch: branch?.branch?.name ?? null,
  }
}

/** Achata a árvore da aba Pendentes na lista de notas que dá para selecionar. */
export const listSelectableInvoices = (hausefulInvoices) => {
  const selectable = []

  ;(hausefulInvoices ?? []).forEach((month) => {
    const fortnights = [
      ...(month.payments_first_half ?? []),
      ...(month.payments_second_half ?? []),
    ]

    fortnights.forEach((realEstateGroup) => {
      ;(realEstateGroup.invoice_by_branches ?? []).forEach((branch) => {
        const invoice = buildSelectableInvoice(realEstateGroup, branch)
        if (invoice.paymentsIds.length) selectable.push(invoice)
      })
    })
  })

  return selectable
}
